import { RecipeFields } from 'config/recipes';

import TitleInputForm from './title/TitleInputForm';
import IngredientsInputForm from './ingredients/IngredientsInputForm';
import TimeToPrepareInputForm from './time_to_prepare/TimeToPrepareInputForm';
import DirectionsInputForm from './directions/DirectionsInputForm';
import AdditionalDataInputForm from './additional_data/AdditionalDataInputForm';

const mapStepToInput = (step) => {
  if (step === RecipeFields.title) return TitleInputForm;
  if (step === RecipeFields.ingredients) return IngredientsInputForm;
  if (step === RecipeFields.timeToPrepare) return TimeToPrepareInputForm;
  if (step === RecipeFields.directions) return DirectionsInputForm;
  if (step === RecipeFields.additionalData) return AdditionalDataInputForm;

  throw new Error('step is invalid');
};

export default mapStepToInput;
